// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Mousewheel,
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
} from 'swiper/modules';
import SwiperInit from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import '../swiper.css';
import Footer from '../components/Footer';
import React, { useEffect, useRef } from 'react';
import { useResize } from '../hooks/useResize';
import Slogun from '../components/Slogun';
import Recommend from '../components/Recommend';

import Aos from 'aos';

function Home(props) {
  const swiperRef = useRef(null);
  const size = useResize();

  const swiperOption = {
    autoHeight: true,
    direction: 'vertical',
    slidesPerView: 'auto',
    // mousewheel: true,
    mousewheel: true,
    spaceBetween: 0,
    speed: 1400,
    parallax: true,
    loop: false,
    pagination: {
      el: '.main_paging',
      clickable: true,
      type: 'bullets',
    },

    // scrollbar: { draggable: true },
    modules: [Mousewheel, Pagination],
    onSlideChange: (swiper) => {
      // console.log('slide change', swiper.activeIndex);
      // // const el = document.getElementById('header');
      // // console.log(el);
      // console.log(props);

      props.activeIdxFunc(swiper.activeIndex);
      // setActiveIdx(swiper.activeIndex);
      // if (swiper.activeIndex !== 0) {
      //   el.classList.add('active-header');
      // } else {
      //   el.classList.remove('active-header');
      // }
      Aos.init();
    },

    onInit: (swiper) => {
      swiperRef.current = swiper;
    },
  };

  const visualSwiperOption = {
    effect: 'fade',
    speed: 1400,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.btn-next',
      prevEl: '.btn-prev',
    },
    pagination: {
      el: '.vpaging',
      clickable: true,
    },

    // scrollbar: { draggable: true },
    modules: [EffectFade, Pagination, Navigation, Autoplay],
  };

  useEffect(() => {
    // DOM 계산 전 size.width가 undefined
    Aos.init();
    // 타입에러 방지를 위해 사용
    if (!size.width) return;

    if (size.width < 1280) {
      // 브라우저 창 크기가 지정한 사이즈 미만일 때
      swiperRef.current?.destroy(true, true);

      // 매개변수는 Swiper 인스턴스 파괴 여부, 사용자 지정 스타일 파괴 여부를 의미
      // https://swiperjs.com/swiper-api 의 swiper.destroy() 부분 참고!
    } else if (size.width >= 1280 && swiperRef.current?.destroyed) {
      // 브라우저 창 크기가 지정 사이즈 이상이고 swiper가 해제되었을 때

      document.getElementById('main').scrollTop = 0;
      swiperRef.current = new SwiperInit('.swiper.main', swiperOption);
    }
  }, [size]);

  return (
    <>
      <div className='h-full'>
        <Swiper id='main' className='main' {...swiperOption}>
          <div className='swiper-container'>
            <SwiperSlide className='h-full visual' id='section1'>
              <Swiper
                id='visual'
                className='overflow-hidden visual-slide'
                {...visualSwiperOption}
              >
                <SwiperSlide>
                  <div className='h-full slide01 bg'></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='h-full slide02 bg'></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='h-full slide03 bg'></div>
                </SwiperSlide>
              </Swiper>
              <div className='!h-auto absolute left-0 top-1/2 -translate-y-1/2 z-10'>
                <div className='txtwrap'>
                  <h3
                    className='text-3xl font-semibold text-white leading-[4rem] md:text-[4.4rem]'
                    data-aos='fade-up'
                  >
                    Make Your Life Better
                  </h3>
                  <p
                    className='text-[1rem] text-white md:text-[1.6rem] md:mt-6'
                    data-aos='fade-up'
                    data-aos-duration='1000'
                  >
                    인류의 더 건강하고 행복한 삶을 위한{' '}
                    <span className='block md:inline-block'>
                      우리의 도전은 계속됩니다
                    </span>
                  </p>
                </div>
                <div className='flex items-center justify-center mt-8'>
                  <div className='w-[17px] h-[26px] cursor-pointer btn-prev'>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/home/ico_slide_prev.svg`}
                      alt=''
                    />
                  </div>
                  <div className='vpaging !w-auto items-center mx-10 md:mx-[60px] flex'></div>
                  <div className='w-[17px] h-[26px] cursor-pointer btn-next'>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/home/ico_slide_next.svg`}
                      alt=''
                    />
                  </div>
                </div>
              </div>
              <div className='scroll'></div>
            </SwiperSlide>
            <SwiperSlide
              className='!h-auto section-02 xl:!h-full'
              id='section2'
            >
              <div className='w-full xl:h-full xl:flex'>
                <div className='xl:w-[60%] h-[100vw] xl:h-auto bg-center bg-[url("/public/assets/images/home/img_section_02_hand.jpg")] bg-cover'></div>
                <div className='relative pl-10 xl:w-[40%] h-auto py-40 w-full flex flex-col justify-center items-start bg-gradient-to-b from-[#ECEDEE] to-[#ffffff]'>
                  <p
                    data-aos='fade-up'
                    className='fade-01 relative z-10 text-2xl leading-9 xl:leading-[3.8rem] xl:text-[2.5rem] text-left font-bold before:content-[""] before:mb-[21px] before:md:mb-[58px] before:block before:w-[80px] before:h-[3px] before:bg-[#000]'
                  >
                    노아는 건강하고 아름다운
                    <br />
                    미래의 꿈을 실현하기 위해
                    <br />
                    한 걸음 한 걸음 나아갈 것을
                    <br />
                    약속드립니다.
                  </p>
                  <p
                    data-aos='fade-up'
                    data-aos-duration='1000'
                    className='relative z-10 hidden mt-6 text-base font-medium text-left fade-02 xl:block lg:text-lg lg:mt-14'
                  >
                    연구개발 전문회사로 굳건히 하여 내실을 다지는 동시에 다양한
                    <br />
                    성장에도 많은 노력을 기울이고 있습니다. 안전하고 건강한 삶을
                    <br />
                    영위할 수 있도록 글로벌 헬스케어 회사로 도약해 나가겠습니다.
                  </p>
                  <p
                    data-aos='fade-up'
                    data-aos-duration='2000'
                    className='relative z-10 block mt-6 text-base font-medium text-left xl:hidden lg:text-lg lg:mt-14'
                  >
                    연구개발 전문회사로 굳건히 하여
                    <br />
                    내실을 다지는 동시에 다양한 성장에도
                    <br />
                    많은 노력을 기울이고 있습니다. 안전하고
                    <br />
                    건강한 삶을 영위할 수 있도록 글로벌
                    <br />
                    헬스케어 회사로 도약해 나가겠습니다.
                  </p>
                  <img
                    className='absolute top-0 right-0 w-[20%] md:w-[25%]'
                    src={`${process.env.PUBLIC_URL}/assets/images/home/ico_section_02_obj.svg`}
                    alt=''
                  />
                  <img
                    className='absolute bottom-[5%] right-[25%] md:right-[35%] w-[20%]'
                    src={`${process.env.PUBLIC_URL}/assets/images/home/ico_section_02_obj2.svg`}
                    alt=''
                  />
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className='!h-auto section-03 md:!h-full'
              id='section3'
            >
              <div className='w-full h-auto pt-16 pb-24 md:h-full'>
                <div className='flex flex-col items-start justify-center h-full pl-6 md:pl-[15%]'>
                  <p className='font-semibold tracking-tight text-[1.4rem] md:text-[2.5rem] mb-2 pl-4 md:pl-10'>
                    Bio And Healthcare
                  </p>
                  <div className='relative h-[198px] md:h-[418px] w-[768px] md:w-[3800px]'>
                    <img
                      className='absolute top-0 left-0 h-full'
                      src={`${process.env.PUBLIC_URL}/assets/images/home/img_bio_healthcare.jpg`}
                      alt=''
                    />
                  </div>
                  <div
                    className='mt-10 md:mt-[4.2rem] text-left md:pl-10 fade-01'
                    data-aos='fade-up'
                    data-aos-duration='1000'
                  >
                    <p className='text-sm font-medium md:text-[1.4rem]'>
                      중앙일보 2022.05.17 11:21
                    </p>
                    <p className='text-[1.4rem] font-bold mt-3 md:text-[2.8rem]'>
                      ‘GB365’, 2022 히트브랜드 대상
                      <br />
                      ‘건강기능식품’ 부문 대상 1위 수상
                    </p>
                    <p className='text-base md:leading-9 md:text-lg mt-7'>
                      노아(구 탑셀㈜)의 ‘GB365’ 제품이{' '}
                      <br className='md:hidden' />
                      JY네트워크에서 주최하고 중앙일보가 후원하는 <br />
                      <span className='md:block'>
                        ‘2022 히트브랜드 대상’에서 ‘건강기능식품’ 부문{' '}
                        <br className='md:hidden' />
                        대상 1위를 수상했다.
                      </span>{' '}
                      고령화 시대에 컴퓨터와 <br className='md:hidden' />
                      스마트 기기 등은 늘어나고 평소 혈관과 관련한{' '}
                      <br className='md:hidden' />
                      성인병에{' '}
                      <span className='md:block'>
                        시달리는 현대인을 위해 만들어진{' '}
                        <br className='md:hidden' />
                        GB365는 혈중 중성지질은 물론 혈행 개선을{' '}
                      </span>
                      <br className='md:hidden' />주 타깃으로 잡고 있다.
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className='!h-auto section-04 xl:!h-full'>
              <div className='flex py-20 justify-center items-center w-full h-full bg-[url("/public/assets/images/home/bg_gb365.png")]'>
                <div className='max-w-[1920px] xl:flex px-5 xl:px-10 justify-center items-center'>
                  <div
                    className='xl:text-left xl:w-[45%] fade-01'
                    data-aos='fade-up'
                    data-aos-duration='1000'
                  >
                    <p className='text-xl font-bold xl:text-3xl'>
                      100% 천연 엔조제놀 액기스
                    </p>
                    <p className='text-4xl xl:text-[3.75rem] font-bold text-[#274274] mt-3 xl:mt-5'>
                      GB365
                    </p>
                    <p className='mt-8 text-base font-medium leading-6 xl:text-xl'>
                      강력한 100% 천연 항산화. 항염증 물질로,
                      <span className='block xl:inline'>
                        뉴질랜드산
                        <br className='hidden xl:block' /> 파이너스 라디아타
                        소나무껍질을
                      </span>{' '}
                      <span className='block xl:inline'>
                        "국제특허 기술인
                        <br className='hidden xl:block' /> 순수 물 추출
                        공법"으로
                      </span>{' '}
                      추출한 100% 천연 건강 기능 식품
                    </p>
                    <a
                      href='/detail'
                      className='inline-block mt-6 md:mt-10 bg-[#103D81] rounded-full text-white font-medium text-sm py-[.94rem] px-6'
                    >
                      view more
                    </a>
                  </div>
                  <div className='xl:w-[55%] px-10 xl:px-5 mt-12'>
                    <img
                      className='max-h-[763px]'
                      src={`${process.env.PUBLIC_URL}/assets/images/home/img_gb365_obj.png`}
                      alt=''
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide className='!h-auto section-05 md:!h-full'>
              <Recommend />
            </SwiperSlide>

            <SwiperSlide
              className='
              !h-auto xl:!h-full flex-col'
            >
              <Slogun />
            </SwiperSlide>
            <SwiperSlide
              className='
              !h-auto md:!h-auto flex-col'
            >
              <Footer />
            </SwiperSlide>
          </div>
        </Swiper>
        <div className='swiper-pagination main_paging'></div>
      </div>
    </>
  );
}

export default Home;
